// extracted by mini-css-extract-plugin
export default {"entity":"SankeyChart_entity__aHGEL"};